const plateAction = (payload) => {
  return {
    type: "atual-plate",
    payload
  }
}
export default plateAction;